/* eslint-disable import/prefer-default-export */
import { Theme } from '@lib/theming'
import { makeStyles } from '@material-ui/core/styles'

export const focusRingBoxShadow = '0 0 0 1px white, 0 0 0 3px #015FCC'

export const useUtilsStyles = makeStyles<Theme>(() => ({
  focusRing: {
    boxShadow: focusRingBoxShadow,
  },
}))
